export const navbarItems = [
    "/",
    "about",
    "portfolio",
    "skills",
    "certificates",
    "contact"
];